// @flow
import React from 'react';
import { string } from 'yup';
import { FILE_INPUT_TYPE } from '@src/formik-utils/consts';
import { convertConfigArrayToMap } from '@src/configuration/utils';
import { Tooltip } from '@presentational/Tooltip';

export const CE1_BASELINE_IMPORT_CONFIG = [
  {
    displayName: 'Input File',
    backendFieldName: 'input_file',
    validation: string().label('Input File').required(),
    inputType: FILE_INPUT_TYPE,
    tooltip: (
      <Tooltip
        link="https://prod-tableau.confluent.io/#/views/CE1BaselineImport/SPE-BaselineImport?:iid=1"
        text="Download Baseline"
      />
    ),
  },
];

export const CE1_BASELINE_IMPORT_CONFIG_MAP = convertConfigArrayToMap(CE1_BASELINE_IMPORT_CONFIG);
